export function getBrand() {
    const shop = window.Shopify?.shop ?? '';
    if (shop.includes('mondetta-modern-ambition')) return 'ma';
    if (shop.includes('mpg-sport-usa')) return 'mmo';
    if (shop.includes('mpg-sport-canada')) return 'mpg';
    throw new Error(`[Algolia] Unrecognized shop: ${shop}`);
}